import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../../components';
import useStyles from '../styles';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';

const IntroButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data: user } = useSelector(selectCurrentUser);
  const currentSubscription = user?.ref?.active_subscription;
  const subProductCode = currentSubscription?.product?.product_code;
  const isActiveSub = subProductCode === 'subscription-pay-as-you-go';
  const defaultTitle = user ? 'Select' : 'Try for free!';
  const currentTitle = isActiveSub ? 'Your current plan' : defaultTitle;
  const onClickHandler = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const url = user ? '/dashboard/plans/checkout' : '/pages/register';
    dispatch(push(url, { productCode: 'subscription-pay-as-you-go' }));
  }, [user, dispatch]);

  return (
    <Button
      disabled={isActiveSub}
      onClick={onClickHandler}
      classes={{
        root: classes.button,
        label: classes.buttonLabel,
      }}
      color="primary"
      variant="contained"
    >
      { currentTitle }
    </Button>
  );
};

export default IntroButton;
